export default __webpack_public_path__ + "static/generative-border-dark-456b5fbc0ae419a08b01320b329c8e28.mp4";